import { useMemo } from 'react';

import { Icon, Text } from '@kanda-libs/ks-design-library';

import { KandaEtikaBadge } from 'components';

import { HEADER_CLASS_NAMES, HEADER_PROPS, PROVIDERS } from './constants';

interface HeaderProps {
  isLoading?: boolean;
  tradingName?: string;
  provider?: string;
  isExampleJob?: boolean;
  isIntroduced?: boolean;
}

const Header = ({
  isLoading = false,
  tradingName = '',
  provider = 'omni',
  isExampleJob = false,
  isIntroduced = false,
}: HeaderProps) => {
  const innerItemProps = { isLoading };

  const providerName = PROVIDERS[provider];

  const isEtika = provider === 'etika' && !isExampleJob;

  const titleProps = useMemo(() => {
    if (isIntroduced) return HEADER_PROPS.introductionTitle;
    if (isEtika) return HEADER_PROPS.etikaTitle;
    return {
      ...HEADER_PROPS.title,
      text: HEADER_PROPS.title.text.replace('{{provider}}', providerName),
    };
  }, [isIntroduced, isEtika, providerName]);

  return (
    <div className={HEADER_CLASS_NAMES.container}>
      {isEtika ? <KandaEtikaBadge /> : null}
      <Text {...titleProps} {...innerItemProps} isLoading={isLoading} />
      <div className={HEADER_CLASS_NAMES.descriptionWrapper}>
        <span className={HEADER_CLASS_NAMES.description}>
          <Text
            {...HEADER_PROPS.description.otherProps}
            {...innerItemProps}
            isLoading={isLoading}
            text={
              provider !== 'humm' ? (
                <>
                  {HEADER_PROPS.description.textLine1}
                  <span className={HEADER_CLASS_NAMES.bold}>
                    {isExampleJob ? 'Example finance ltd' : providerName}
                  </span>
                  {HEADER_PROPS.description.textLine2}
                  <span className={HEADER_CLASS_NAMES.bold}>{tradingName}</span>
                  {HEADER_PROPS.description.textLine3}
                </>
              ) : (
                "Ideal4Finance is a credit broker and we'll help you apply for credit from our lender, Humm Group Limited."
              )
            }
          />
        </span>

        <Icon
          {...HEADER_PROPS.icon}
          {...innerItemProps}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

Header.displayName = 'ApplyForFinance-Desktop-Welcome-Header-view';

export default Header;
